import React, { useContext } from 'react';
import 'stream-chat-react/dist/css/index.css';

import { Chat, ChatView } from '../../../../../chat';
import FirebaseContext from '../../../../../context/FirebaseContext';
import UserContext from '../../../../../context/UserContext';
import useSessionStore from '../../../../../hooks/useSessionStore';
import WebMediaRecorder from '../../WebMediaRecorder';

import {
  ChannelViewContainer,
} from './styles';

const ChatSideBar = () => {
  const {
    firebase,
  } = useContext(FirebaseContext);

  const {
    userId: chatUserId,
  } = useContext(UserContext);
  const sessionStore = useSessionStore();
  const webMediaRecorder = new WebMediaRecorder();

  return (
    <ChannelViewContainer>
      <Chat
        chatView={ChatView.SidebarView}
        firebase={firebase}
        sessionStore={sessionStore}
        chatUserId={chatUserId}
        mediaRecorder={webMediaRecorder}
        parentApp="web"
      />
    </ChannelViewContainer>
  );
};

export default ChatSideBar;
